import { getApiClient } from '@src/services/api-client'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { SwitchedLoanConditionsDto } from './SwitchedLoanConditionsDto'

async function fetchSwapApplicantsSimulation(financingProgramId: string, creditApplicationId: string) {
  const apiClient = getApiClient()
  const url = `/Applications/${financingProgramId}/${creditApplicationId}/SwapApplicantsSimulation`
  const response = await apiClient.get<SwitchedLoanConditionsDto>(url)
  return response.data
}

async function applySwapApplicantsSimulation(financingProgramId: string, creditApplicationId: string) {
  const apiClient = getApiClient()
  const url = `/Applications/${financingProgramId}/${creditApplicationId}/SwapApplicants`
  await apiClient.post(url) 
}

export function useSwapApplicantsSimulation(
  financingProgramId: string,
  creditApplicationId: string,
  enabled = true
) {
  return useQuery<SwitchedLoanConditionsDto, AxiosError>({
    queryKey: ['swapApplicantsSimulation', financingProgramId, creditApplicationId],
    queryFn: () => fetchSwapApplicantsSimulation(financingProgramId, creditApplicationId),
    enabled,
    staleTime: 1 * 60 * 1000, // 1 minute
  })
}

export function useApplySwapApplicants() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ financingProgramId, creditApplicationId }: { financingProgramId: string; creditApplicationId: string }) => {
      await applySwapApplicantsSimulation(financingProgramId, creditApplicationId)
      void queryClient.invalidateQueries({ queryKey: ['swapApplicantsSimulation', financingProgramId, creditApplicationId] })
    },
  })
}

export default {
  fetchSwapApplicantsSimulation,
  applySwapApplicantsSimulation,
}